/** The analyst never has a legitimate reason to render an external image — every visual it produces
 * is a structured `table`/`chart` output block, not markdown imagery. `MarkdownModule` is configured
 * with `SecurityContext.HTML`, which allowlists `<img src>` for http(s) by design, so any image
 * syntax that reaches this content becomes a live `<img>` on render and fires an outbound request
 * with no click needed. Strips both vectors a model could use to produce one: markdown `![]()`
 * syntax and raw `<img>` HTML (marked passes raw HTML through untouched, so sanitization alone
 * would still let a literal `<img>` tag through). */
const MARKDOWN_IMAGE_PATTERN = /!\[[^\]]*\]\([^)]*\)/g;
const HTML_IMAGE_TAG_PATTERN = /<img\b[^>]*>/gi;

export function stripAnalystAnswerImages(content: string): string {
  return content.replace(MARKDOWN_IMAGE_PATTERN, '').replace(HTML_IMAGE_TAG_PATTERN, '');
}
